import React, { useState } from "react";

import { VariantSwitcher } from "../../components/VariantSwitcher";
import Variant1 from "./Variant1";
import Variant2 from "./Variant2";
import Variant3 from "./Variant3";
import Variant4 from "./Variant4";

const CONCEPTS = [
  {
    variantNumber: 1,
    label: "Hierarchical chip selector",
    lastUpdated: "Mar 17, 2026",
  },
  {
    variantNumber: 2,
    label: "Accordion list",
    lastUpdated: "Mar 18, 2026",
  },
  {
    variantNumber: 3,
    label: "Search + browse chips",
    lastUpdated: "Mar 18, 2026",
  },
  {
    variantNumber: 4,
    label: "Two-shelf guided flow",
    lastUpdated: "Mar 18, 2026",
  },
];

export const prototypeMeta = {
  name: "NuxCategorySelectorPage",
  creator: "Tony Chen",
  ownerGithub: "tonychen",
};

export default function NuxCategorySelectorPage() {
  const [activeVariant, setActiveVariant] = useState(
    CONCEPTS[0].variantNumber
  );

  const renderVariant = () => {
    switch (activeVariant) {
      case 1:
        return <Variant1 />;
      case 2:
        return <Variant2 />;
      case 3:
        return <Variant3 />;
      case 4:
        return <Variant4 />;
      default:
        return <Variant1 />;
    }
  };

  return (
    <div>
      <VariantSwitcher
        activeVariant={activeVariant}
        onVariantChange={setActiveVariant}
        concepts={CONCEPTS}
        featureTitle="NUX Category Selector"
      />
      {renderVariant()}
    </div>
  );
}
